export default [
    {
        path: "/security/roles",
        name: "roles",
        meta: { title: "roles", authRequired: true },
        component: () => import("../views/security/roles.vue"),
    },
    {
        path: "/security/users",
        name: "users",
        meta: { title: "users", authRequired: true },
        component: () => import("../views/security/users.vue"),
    },
    {
        path: "/security/new-role/:id?",
        name: "new-role",
        meta: { title: "roles", authRequired: true },
        component: () => import("../views/security/new-role.vue"),
    },
    {
        path: "/security/view-role",
        name: "view-role",
        meta: { title: "roles", authRequired: true },
        component: () => import("../views/security/view-role.vue"),
    },
    {
        path: "/security/new-user/:id?",
        name: "new-user",
        meta: { title: "users", authRequired: true },
        component: () => import("../views/security/new-user.vue"),
    },
    {
        path: "/security/view-user",
        name: "view-user",
        meta: { title: "users", authRequired: true },
        component: () => import("../views/security/view-user.vue"),
    },
    {
        path: "/security/pe-structure",
        name: "pe-structure",
        meta: { title: "Procuring Entity (PE) Structure", authRequired: true },
        component: () => import("../views/security/pestructure.vue"),
    },
]